import { UserAuth } from "@/business/auth/domain/login";
import { userAuthStore } from "@/business/auth/infrastructure/store/userAuthStore";

export const getUserSession = {
  execute(): UserAuth | null {
    return userAuthStore().isEmpty.value
      ? null
      : userAuthStore().memoryUserAuth;
  },
};
